import LocaleKeys from '../../../locales/keys';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  introPriceText: {
    fontFamily: 'Formula1-Bold',
    fontSize: '18px',
    margin: 0,
    paddingLeft: 0,
    paddingTop: '20px',
    paddingBottom: '15px',
    letterSpacing: '.2px',
    fontWeight: '400',
    padding: '0 0 5px 10px',
    textTransform: 'none',
  },
  subscriptionLink: {
    fontFamily: 'Formula1-Bold',
    fontSize: '18px',
    margin: 0,
    paddingLeft: 0,
    paddingTop: '20px',
    paddingBottom: '15px',
    letterSpacing: '.2px',
    textTransform: 'none',
    cursor: 'pointer',
  },
  pageLinks: {
    borderBottom: 'none',
    color: '#333',
    textDecoration: 'none',
    fontWeight: 600,
    '&:hover': {
      color: `${theme.palette.custom.darkBlue}`,
    },
    '&:focus': {
      color: `${theme.palette.custom.darkBlue}`,
    },
  },
}));

const IntroPricingUpgradeTemplate = ({
  subscriptionProps,
  subscriptionCycleDate,
  isFreeTrial,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const ischangePricingPlan = !!Object.keys(
    subscriptionProps?.changePricingPlan || {},
  ).length;

  const isCancelableNode = subscriptionProps?.isCancelable;
  const isDisplayUpgradeEndDate = ischangePricingPlan || !isCancelableNode;
  const isRenew = subscriptionProps?.isSubscriptionRenew;
  const isIap = subscriptionProps?.isIap;

  return (
    <Box>
      {(isDisplayUpgradeEndDate || isFreeTrial) && !isRenew && !isIap && (
        <Box>
          <Box className={classes.introPriceText}>
            {t(
              LocaleKeys.subscriptionInfo.subscriptions
                .subscriptionItemCycleEndDateLabel,
            )}
          </Box>
          <Box>
            <Typography variant="body1">{subscriptionCycleDate}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default IntroPricingUpgradeTemplate;
